import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import deepmerge from 'deepmerge';
import { isArray } from '@jd/jmtd-tools/es/is';
import themeConfigs from '../theme/normalLineChart';
import ChartHOC from '../ChartHOC';
var NormalLineChart = ChartHOC(themeConfigs, function (_ref) {
  var scene = _ref.scene,
      series = _ref.series,
      categories = _ref.categories,
      config = _ref.config,
      themeConfig = _ref.themeConfig;
  var tempConfig = deepmerge(themeConfig, config !== null && config !== void 0 ? config : {}, {
    arrayMerge: function arrayMerge(target, source) {
      return source;
    }
  });
  tempConfig.xAxis.type = 'category';
  tempConfig.xAxis.data = categories;

  if (isArray(config.yAxis)) {
    tempConfig.yAxis = config.yAxis.map(function (item) {
      var _themeConfig$yAxis;

      return deepmerge((_themeConfig$yAxis = themeConfig.yAxis) !== null && _themeConfig$yAxis !== void 0 ? _themeConfig$yAxis : {}, item);
    });
  }

  switch (scene) {
    // 折线图
    case 'line':
      tempConfig.series = series.map(function (item) {
        var _tempConfig$series;

        return deepmerge(_objectSpread(_objectSpread({}, item), {}, {
          name: item.name,
          data: item.data,
          type: 'line',
          smooth: false
        }), (_tempConfig$series = tempConfig.series) !== null && _tempConfig$series !== void 0 ? _tempConfig$series : {});
      });
      break;
    // 曲线图

    default:
      tempConfig.series = series.map(function (item) {
        var _tempConfig$series2;

        return deepmerge(_objectSpread(_objectSpread({}, item), {}, {
          name: item.name,
          data: item.data,
          type: 'line',
          smooth: true
        }), (_tempConfig$series2 = tempConfig.series) !== null && _tempConfig$series2 !== void 0 ? _tempConfig$series2 : {});
      });
  }

  return deepmerge({}, tempConfig);
});
export default NormalLineChart;